import React, { useState, useEffect } from 'react';
import InputProductsTile from './InputProductsTile';

export default function InputProducts({
  className,
  name,
  value,
  products,
  setValue,
  petTypes,
  currentPetType,
}) {
  const [ openSectionKey, setOpenSectionKey ] = useState(null);
  
  // if the currentPetType changes we will want to clear out the selected products
  useEffect(() => {
    setValue({ [name] : (value ? value : []) })
  }, [ currentPetType ])

  const addItem = product => {
    const newValue = (
    value.filter(p => p.handle === product.handle).length === 0
    ? [...value, product]
    : value.filter(p => p.handle !== product.handle)
    );
    setValue({ [name] : newValue });
  }

  const petType = petTypes.find(petType => petType._id === currentPetType);

  const filteredProducts = Object.keys(products).reduce((acc, key) => {
    const category = products[key];
    const filteredCategory = category.filter(product => product.tags.toLowerCase().includes(petType.name.toLowerCase()))
    return { ...acc, ...(filteredCategory.length > 0 ? { [key] : filteredCategory } : {}) }
  }, {})


  return (
  <div className={`input-products ${className || ''}`}>
    <div className="input-products__list mb40">
    {
      Object.keys(filteredProducts).map((key) => (
        <div className="list__category" key={key}>
          <div
            className="list__category-title bb1-s-gray-light p24 curp df aic jcsb"
            onClick={() => setOpenSectionKey(openSectionKey === key ? null : key)}
            onKeyDown={e => (e.key === 'Enter') && setOpenSectionKey(key)}
            tabIndex="0"
          >
            <h3 className="category-tile__heading fz20 fw600 ff-pgc">
              { key }
            </h3>
            <span className="category-tile__toggle-icon fz25 fw600">
              { openSectionKey === key ? '-' : '+' }
            </span>
          </div>
          <div className={`list__category-products aic jcc fxww mb40 mt24 ${openSectionKey === key ? 'df' : 'dn'}`}>
          {
            filteredProducts[key].map(product => (
            <InputProductsTile
              key={product.id}
              className="mr24"
              product={product}
              addItem={addItem}
              selected={value.filter(p => p.id === product.id).length > 0}
            />)
            )
          }
          </div>
        </div>
      ))
    }
    </div>
    <h3 className="fz20 mb24">
      Selected Products:
    </h3>
    <div className="input-products__selected">
    {value.length > 0 
    ? value.map(product => (
        <button
          key={product.id}
          className="curp p10 mr10 mb10 bgc-transparent bd2-s-black fw600"
          onClick={() => addItem(product)}
        >
          &times;&nbsp;{product.title}
        </button>
      ))
    : <span className="fz20 fw600 p10 bd2-s-black">No products selected</span>
    }
    </div>
  </div>
  )
}
